// Do not edit this file
export const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL;
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const ADMIN_PANEL_URL = process.env.NEXT_PUBLIC_ADMIN_PANEL_URL;
export const API_URL = BASE_URL + "/api/v1/";
export const IMAGE_URL = BASE_URL + "/storage/images/";
export const MAP_API_KEY = process.env.NEXT_PUBLIC_MAP_API_KEY;
export const G_TAG = process.env.NEXT_PUBLIC_GOOGLE_MEASUREMENT_ID;
export const UNPAID_STATUSES = ["progress", "canceled", "rejected"];
export const EXTERNAL_PAYMENTS = [
  "stripe",
  "razorpay",
  "paystack",
  "moyasar",
  "paytabs",
  "mercado-pago",
  "flutterWave",
  "paypal",
];
